@if (isTransparent){
<a class="btn btn-default btn-white" href="{{ url }}" target="_blank">
  <i *ngIf="hasIcon" class="{{ iconName }}"></i>
  {{ text }}</a
>
} @else {
<a
  class="btn btn-default primary-btn gradient"
  href="{{ url }}"
  target="_blank"
>
  {{ text }}</a
>
}
